module.exports = __webpack_public_path__ + "media/DDYC.a595a7ae.mp3";